import React from 'react';
import { Link } from 'react-router-dom';
import { ARWMButton } from '../components/ARWMButton';
import { Card, CardHeader, CardTitle, CardContent } from '../components/Card';
import { CheckCircle } from 'lucide-react';
import { useSEO } from '../hooks/useSEO';
export function Adherents() {
  useSEO("Adhérents - ARWM | Rejoignez l'Association des Restaurateurs", "Devenez membre de l'ARWM et bénéficiez d'un réseau professionnel d'excellence, de formations exclusives et d'une représentation auprès des autorités.");
  const benefits = ['Représentation auprès des autorités locales et nationales', "Accès à un réseau professionnel d'excellence", 'Participation aux événements et formations exclusives', 'Visibilité accrue pour votre établissement', 'Veille réglementaire et juridique', 'Accompagnement personnalisé dans vos projets'];
  const steps = [{
    number: '1',
    title: 'Pré-inscription',
    description: 'Remplissez le formulaire en ligne avec les informations de votre établissement'
  }, {
    number: '2',
    title: 'Validation',
    description: 'Notre bureau examine votre candidature sous 5 jours ouvrables'
  }, {
    number: '3',
    title: 'Cotisation',
    description: 'Réglez votre cotisation annuelle (4000-6000 Dhs selon la catégorie)'
  }, {
    number: '4',
    title: 'Adhésion',
    description: "Recevez votre certificat d'adhésion et accédez à tous les services"
  }];
  const restaurants = ["L'étoile Du Musée", 'Naama', 'Palais Dar Soukkar', 'Dar Zellij', 'La Table Ocre', 'Le Grand Bazar', 'Le Douar', 'Diaffa', 'Ksar El hamra', 'Dar Essalam', 'Dar Yacout', 'Chez Ali', 'Le Trou au Mur', 'Café Arabe', 'La Bohème Majorelle', 'Valse', 'La Rôtisserie de La Paix', 'Le petit cornichon', 'Baromètre', 'Bagatelle', 'Nomad', 'Point Bar', 'Le blokk', 'La Bohème Agafay', 'Dar Moha', 'Cantobar', "Le grand café de l'atlas", 'Farmers', 'Terrasse des épices', 'M', 'Torotoro', 'Akira Back', "L'auberge espagnole", 'Noto Marrakech', 'Catanzaro', 'Mamma Mia', 'Vita Nova', 'La Trattoria', 'Le Jardin'];
  return <div className="w-full" data-id="element-77">
      {/* Hero */}
      <section className="py-32 px-4 bg-arwm-maroon" data-id="element-78">
        <div className="max-w-[1280px] mx-auto text-center" data-id="element-79">
          <h1 className="font-cormorant text-7xl font-bold text-white mb-6" data-id="element-80">
            Nos Adhérents
          </h1>
          <p className="font-josefin text-xl text-arwm-cream max-w-3xl mx-auto" data-id="element-81">
            Rejoignez une communauté d'excellence dédiée à la gastronomie
            marocaine
          </p>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-20 px-4 bg-white" data-id="element-82">
        <div className="max-w-[1280px] mx-auto" data-id="element-83">
          <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4 text-center" data-id="element-84">
            Avantages
          </p>
          <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-12 text-center" data-id="element-85">
            Pourquoi Adhérer ?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-86">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start space-x-4" data-id="element-87">
                <CheckCircle className="w-6 h-6 text-arwm-maroon flex-shrink-0 mt-1" data-id="element-88" />
                <p className="font-josefin text-lg text-arwm-dark-text" data-id="element-89">
                  {benefit}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-20 px-4 bg-arwm-light-gray" data-id="element-90">
        <div className="max-w-[1280px] mx-auto" data-id="element-91">
          <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4 text-center" data-id="element-92">
            Démarches
          </p>
          <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-12 text-center" data-id="element-93">
            Processus d'Adhésion
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-94">
            {steps.map(step => <Card key={step.number} data-id="element-95">
                <CardContent className="py-8" data-id="element-96">
                  <div className="w-16 h-16 bg-arwm-maroon text-arwm-cream flex items-center justify-center font-cormorant text-3xl font-bold mb-6" data-id="element-97">
                    {step.number}
                  </div>
                  <h3 className="font-cormorant text-2xl font-bold text-arwm-dark-text mb-4" data-id="element-98">
                    {step.title}
                  </h3>
                  <p className="font-josefin text-arwm-dark-text" data-id="element-99">
                    {step.description}
                  </p>
                </CardContent>
              </Card>)}
          </div>
          <div className="text-center mt-12" data-id="element-100">
            <p className="font-josefin text-lg text-arwm-dark-text mb-6" data-id="element-101">
              <strong data-id="element-102">Cotisation annuelle :</strong> 4000 à 6000 Dhs selon la
              catégorie de votre établissement
            </p>
            <Link to="/contact" data-id="element-103">
              <ARWMButton data-id="element-104">Demander votre adhésion</ARWMButton>
            </Link>
          </div>
        </div>
      </section>

      {/* Members List */}
      <section className="py-20 px-4 bg-white" data-id="element-105">
        <div className="max-w-[1280px] mx-auto" data-id="element-106">
          <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-maroon mb-4 text-center" data-id="element-107">
            Nos Membres
          </p>
          <h2 className="font-cormorant text-5xl font-bold text-arwm-dark-text mb-12 text-center" data-id="element-108">
            Nos Restaurants Membres
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-109">
            {restaurants.map((restaurant, index) => <Card key={index} data-id="element-110">
                <CardContent className="py-6 text-center" data-id="element-111">
                  <h3 className="font-cormorant text-xl font-bold text-arwm-dark-text" data-id="element-112">
                    {restaurant}
                  </h3>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-4 bg-arwm-maroon" data-id="element-113">
        <div className="max-w-[1280px] mx-auto text-center" data-id="element-114">
          <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-cream mb-4" data-id="element-115">
            Rejoignez-nous
          </p>
          <h2 className="font-cormorant text-5xl font-bold text-white mb-6" data-id="element-116">
            Prêt à Nous Rejoindre ?
          </h2>
          <p className="font-josefin text-xl text-arwm-cream mb-10 max-w-2xl mx-auto" data-id="element-117">
            Devenez membre de l'ARWM et participez activement au développement
            de la gastronomie à Marrakech
          </p>
          <Link to="/contact" data-id="element-118">
            <ARWMButton data-id="element-119">Contactez-nous</ARWMButton>
          </Link>
        </div>
      </section>
    </div>;
}